import { DeleteGalleryFnReq, DeleteGalleryFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export class DeleteGalleryInteractor {
  private readonly fn = httpsCallable<DeleteGalleryFnReq, DeleteGalleryFnRes>(
    this.functions,
    'deleteGallery',
  );

  constructor(private readonly functions: Functions) {}

  public async execute(galleryId: string): Promise<DeleteGalleryFnRes> {
    const res = await this.fn({ galleryId });
    return res.data;
  }
}
